import {useGlobalContext} from './context'

export default function Form() {

    const {query,setQuery,error} = useGlobalContext()

    function handleChange(e){
      const newValue = e.target.value
        setQuery(newValue)
    }

    return (
        <div>
            <form className="search-form" onSubmit={e => e.preventDefault()}>
             <h1><span>CinemaCrave</span></h1>
             <h2>Search movies</h2>
             <input type="text" className="form-input" value={query} onChange={handleChange} maxLength="50"/>
             {error.show && <div className="error">{error.msg}</div>}
            </form>
        </div>
    )
}
